import React, { useEffect, useState } from 'react';

import { GetSeoTagsResponse } from '../../../Api/CRM/Responses/SeoTagResponse';
import ActionButton from '../../elements/ActionButton';
import DeleteButton from '../../elements/DeleteButton';
import EditButton from '../../elements/EditButton';
import ViewButton from '../../elements/ViewButton';
import Paginator from '../../elements/paginator';
import TableDataValue from '../../elements/tableDataValue';
import { PERMISSION } from '../../helpers/Permissions';
import axios from '../../services/MyAxios';

import Card from 'crm/elements/common/Card';

function SeoTagList() {
    const url = '/crea/api/seo_tag';
    const [seoTags, setSeoTags] = useState<GetSeoTagsResponse>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);

    useEffect((page = 1) => {
        getSeoTags(page);
    }, []);

    function getSeoTags(page) {
        axios.get(`${url}?page=${page}`).then((response) => {
            setSeoTags(response.data.data);
            setCurrentPage(response.data.current_page);
            setLastPage(response.data.last_page);
        });
    }

    function getSeoTagsList() {
        return seoTags.map(
            ({ id, route, title, meta_description, meta_keywords, og_description, og_image, og_url, og_type }) => (
                <tr key={id}>
                    <td>
                        <TableDataValue value={route} />
                    </td>
                    <td>
                        <TableDataValue value={title} />
                    </td>
                    <td>
                        <TableDataValue value={meta_description} />
                    </td>
                    <td>
                        <TableDataValue value={meta_keywords} />
                    </td>
                    <td>
                        <TableDataValue value={og_description} />
                    </td>
                    <td>
                        <TableDataValue value={og_image} />
                    </td>
                    <td>
                        <TableDataValue value={og_url} />
                    </td>
                    <td>
                        <TableDataValue value={og_type} />
                    </td>
                    <td>
                        <ViewButton url={`/seo_tags/${id}`} permissions={[PERMISSION.VIEW_SEO_TAG]} />
                        <EditButton url={`/seo_tags/${id}/edit`} permissions={[PERMISSION.UPDATE_SEO_TAG]} />
                        <DeleteButton
                            url={`/crea/api/seo_tag/${id}`}
                            action={() => getSeoTags(1)}
                            permissions={[PERMISSION.DELETE_SEO_TAG]}
                        />
                    </td>
                </tr>
            )
        );
    }

    return (
        <>
            <ActionButton title="Create new Seo Tag" url="/seo_tags/create" permissions={[PERMISSION.CREATE_SEO_TAG]} />
            <Card title="Seo Tags">
                <div className="table-responsive">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Route</th>
                                <th>Title</th>
                                <th>Meta Description</th>
                                <th>Meta Keywords</th>
                                <th>OG Description</th>
                                <th>OG Image</th>
                                <th>OG URL</th>
                                <th>OG Type</th>
                                <th />
                            </tr>
                        </thead>
                        <tbody>{getSeoTagsList()}</tbody>
                    </table>
                    <Paginator currentPage={currentPage} lastPage={lastPage} onPageChange={getSeoTags} />
                </div>
            </Card>
        </>
    );
}

export default SeoTagList;
